// import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// const initialState: any = {
//   examQuestionBank: []
// };

// export const examQuestionBankSlice = createSlice({
//   name: 'examQuestionBank',
//   initialState,
//   reducers: {
//     setExamQuestionBank: (state, action: PayloadAction<any[]>) => {
//       state.examQuestionBank = action.payload;
//     }
//   }
// });

// export const { setExamQuestionBank } = examQuestionBankSlice.actions;

// export default examQuestionBankSlice.reducer;



// store/slices/exam/examQuestionBankSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Question {
  _id: string;
  question: string;
  options: string[];
  answer: string;
  thumbnailUrl: string | null;
  selectedOption: string | null;
}

interface ExamState {
  examQuestionBank: Question[];
}

const initialState: ExamState = {
  examQuestionBank: []
};

export const examQuestionBankSlice = createSlice({
  name: 'examQuestionBank',
  initialState,
  reducers: {
    setExamQuestionBank: (state, action: PayloadAction<Question[]>) => {
      state.examQuestionBank = action.payload;
    },
    // ← new reducer:
    setSelectedOption: (
      state,
      action: PayloadAction<{ questionId: string; selectedOption: string }>
    ) => {
      const { questionId, selectedOption } = action.payload;
      const q = state.examQuestionBank.find((q) => q._id === questionId);
      if (q) {
        q.selectedOption = selectedOption;
      }
    }
  }
});

export const { setExamQuestionBank, setSelectedOption } = examQuestionBankSlice.actions;
export default examQuestionBankSlice.reducer;
